import ApiClient from '../ApiClient';

class ShoutoutChannel extends ApiClient {
  constructor() {
    super('channels/shoutout_channel', { accountScoped: true });
  }
}

export default new ShoutoutChannel();
